import mutationsTypes from '@/vuex/documentos-favoritos/mutations-types.js'

const types = {
  ...mutationsTypes,
  BUSCAR_FAVORITOS: 'BUSCAR_FAVORITOS',
  DESFAVORITAR_DOCUMENTO: 'DESFAVORITAR_DOCUMENTO',
  ALTERNAR_ACOMPANHAMENTO: 'ALTERNAR_ACOMPANHAMENTO',
  GET_ULTIMA_TRAMITACAO: 'GET_ULTIMA_TRAMITACAO',
  ATUALIZA_MARCADORES: 'ATUALIZA_MARCADORES'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/documentos-favoritos/actions-types.js